// src/screens/CustomHeader.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBell, FaQuestionCircle } from 'react-icons/fa';
import { getFirestore, collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';
import { auth } from '../firebase';
import logo from './logo.png';
import './CustomHeader.css';

const CustomHeader = () => {
  const [hasNotifications, setHasNotifications] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkForUnreadNotifications = async () => {
      const db = getFirestore();
      const user = auth.currentUser;
      if (!user) return;

      const avisosRef = collection(db, 'avisos');
      const q = query(avisosRef, where('userId', '==', user.uid), where('status', '==', 'nao lido'));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        setHasNotifications(true);
        setNotificationCount(querySnapshot.size);
        setNotifications(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } else {
        setHasNotifications(false);
        setNotificationCount(0);
      }
    };

    checkForUnreadNotifications();
  }, []);

  const markAsRead = async (notificationId) => {
    const db = getFirestore();
    const avisoRef = doc(db, 'avisos', notificationId);
    await updateDoc(avisoRef, { status: 'lido' });

    setNotifications(notifications.filter(notification => notification.id !== notificationId));
    setNotificationCount(notificationCount - 1);

    if (notificationCount - 1 === 0) {
      setHasNotifications(false);
    }
  };

  const toggleModal = () => {
    setModalVisible(!modalVisible);
  };

  return (
    <header className="header-container">
      <div className="logo-container" onClick={() => navigate('/home')}>
        <img src={logo} alt="Logo" className="logo" />
      </div>
      <div className="icon-container">
        <button onClick={toggleModal} className="icon-button">
          <FaBell size={24} color={hasNotifications ? '#FD4D4D' : '#2A9D8E'} />
          {hasNotifications && <span className="badge">{notificationCount}</span>}
        </button>
        <button onClick={() => navigate('/support')} className="icon-button">
          <FaQuestionCircle size={24} color="#2a9d8f" />
        </button>
      </div>

      {modalVisible && (
        <div className="modal">
          <div className="modal-content">
            <h2 className="modal-title">Notificações</h2>
            <div className="notifications-list">
              {notifications.length > 0 ? (
                notifications.map(notification => (
                  <div key={notification.id} className="notification-item">
                    <p className="notification-text">{notification.mensagem}</p>
                    <p className="notification-time">
                      {notification.createdAt ? 
                        `Horário: ${new Date(notification.createdAt.seconds * 1000).toLocaleString()}` : 
                        `Horário: ${notification.horario}`}
                    </p>
                    <button onClick={() => markAsRead(notification.id)} className="mark-as-read-button">
                      Marcar como lido
                    </button>
                  </div>
                ))
              ) : (
                <p className="no-notifications-text">Você não tem avisos novos</p>
              )}
            </div>
            <button onClick={toggleModal} className="close-button">Fechar</button>
          </div>
        </div>
      )}
    </header>
  );
};

export default CustomHeader;

